import { css } from "@emotion/react"

const styles = css`
  html {
    box-sizing: border-box;
    overflow-y: auto;
  }
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }
  .clearfix::before,
  .clearfix::after {
    display: table;
    content: "";
  }
  .clearfix::after {
    clear: both;
  }
  body {
    margin: 0;
    color: hsla(0, 0%, 0%, 0.8);
    background: #282b2f;
    overflow: hidden;
    min-height: 100vh;
    letter-spacing: -0.035em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    transform-origin: 0 0;
  }
  a,
  h1,
  h2,
  h3,
  h4 {
    font-weight: 900;
  }
  svg:not(:root) {
    overflow: hidden;
  }
  @media only screen and (max-width: 480px) {
    html {
      font-size: 100%;
    }
  }
  .pgContainer {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
  .pgContent {
    margin-bottom: 52px;
    box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.5);
  }
  .pgContent,
  .tl-edges,
  .tl-wrapper,
  .layout-wrapper,
  .page,
  .layout-inner {
    display: flex;
    flex: auto;
  }
  .tl-wrapper {
    flex-direction: column;
  }
  .copy {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 1.25rem;
    color: rgba(243, 255, 255, 0.72);
    position: absolute;
    bottom: 0;
    left: 0;
    height: 52px;
    background: var(--byfolio-color-ink);
    border-top: 1px solid rgba(139, 220, 255, 0.12);
  }
  .copy-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    width: min(1380px, 100%);
    margin: 0 auto;
    font-size: 0.75rem;
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }
  @media (min-width: 2000px) {
    .copy-inner {
      width: min(1780px, 100%);
    }
  }
  @media (max-width: 520px) {
    .copy-tagline {
      display: none;
    }
  }
  .layout-wrapper {
    min-height: 100%;
    display: flex;
  }
  .layout-inner {
    width: 100%;
  }
  .white.layout-wrapper .layout-inner {
    background: #fff;
  }
  .white .data-section {
    color: #000;
  }
  .icon {
    display: block;
    width: 1.5em;
    height: 1.5em;
    margin: 0 auto;
    fill: currentColor;
  }
  a {
    color: #2fa0ec;
    text-decoration: none;
    outline: none;
  }
  a:hover,
  a:focus {
    color: #74777b;
    outline: none;
  }
  .hidden {
    position: absolute;
    overflow: hidden;
    width: 0;
    height: 0;
    pointer-events: none;
  }
  .bgPageColor {
    color: var(--byfolio-color-ink);
    position: absolute;
    bottom: 0;
  }
`

export default styles
